type IsMobile = boolean;
type IsOpenInModal = boolean;

export const getBoundAdditionalValue = (
  value: number,
  isOpenInModal: IsOpenInModal,
) => (isOpenInModal ? value : 0);

interface GetLeftPositionProps {
  leftQuill: number;
  leftCursor: number;
  isOpenInModal: IsOpenInModal;
  isMobile: IsMobile;
}

export const getLeftPosition = ({
  leftQuill,
  leftCursor,
  isOpenInModal,
  isMobile,
}: GetLeftPositionProps) => {
  if (isMobile) {
    return isOpenInModal ? '20px' : '5%';
  }

  return `${leftCursor + getBoundAdditionalValue(leftQuill, isOpenInModal)}px`;
};

interface GetWidthPositionProps {
  isOpenInModal: IsOpenInModal;
  isMobile: IsMobile;
}

export const getWidthPosition = ({
  isOpenInModal,
  isMobile,
}: GetWidthPositionProps) => {
  if (isMobile) {
    return isOpenInModal ? 'calc(100vw - 40px)' : '90%';
  }

  return 'auto';
};
